// extracted by mini-css-extract-plugin
export default {"button":"SimpleButton_button__OZNzV","button_disabled":"SimpleButton_button_disabled__QO-S7"};